export type SearchPropertyMap = Map<string, string>;

export interface ISearchProperty {
    text: string;
    value: string;
}

export const searchPropertyMap: SearchPropertyMap = new Map<string, string>([
    ["name", "Имя"],
    ["user.username", "Логин"],
    ["", "Id"],
    ["user.legacyUser", "Legacy Id"],
]);

export const searchProperties: ISearchProperty[] = Array.from(searchPropertyMap.entries()).map<ISearchProperty>(i => {
    return {
        text: i[1],
        value: i[0],
    }
});
